<template>
  <tr class="grid grid-cols-1 bg-white py-3 even:bg-gray-100/60 lg:table-row lg:grid-cols-2 lg:py-0 lg:even:bg-white">
    <td label="Nro. trámite"
      class="flex items-center py-1.5 pl-4 text-left text-sm text-gray-500 before:w-40 before:min-w-[9rem] before:font-semibold before:content-[attr(label)] lg:table-cell lg:py-4 lg:pl-0 lg:pr-8 lg:text-right before:lg:hidden">
      {{ nroTramite }}
    </td>

    <td label="Fecha trámite"
      class="flex items-center py-1.5 pl-4 text-left text-sm text-gray-500 before:w-40 before:min-w-[9rem] before:font-semibold before:content-[attr(label)] lg:table-cell lg:py-4 lg:pl-0 lg:pr-8 lg:text-right before:lg:hidden">
      <span class="font-medium">{{ fechaTramite }}</span>
    </td>

    <td label="Fecha instrumento"
      class="flex items-center py-1.5 pl-4 text-left text-sm text-gray-500 before:w-40 before:min-w-[9rem] before:font-semibold before:content-[attr(label)] lg:table-cell lg:py-4 lg:pl-0 lg:pr-8 lg:text-right before:lg:hidden">
      <span class="font-medium">{{ solicitud.fechaInstrumento | date }}</span>
    </td>

    <td label="Tipo de solicitud"
      class="flex items-center py-1.5 pl-4 text-left text-sm text-gray-500 before:w-40 before:min-w-[9rem] before:font-semibold before:content-[attr(label)] lg:table-cell lg:py-4 lg:pl-0 lg:pr-8 lg:text-right before:lg:hidden">
      <SolicitudBadgeTipo :tipo="solicitud.tipo" text-size-class="text-sm" />
    </td>

    <td
      class="flex items-center justify-center pl-4 pt-1.5 text-left text-sm text-gray-500 md:justify-start lg:table-cell lg:py-4 lg:pl-0 lg:pr-8 lg:text-right">
      <SolicitudBadgeEstado :estado="solicitud.estado" text-size-class="text-sm" />
    </td>

    <td
      class="mt-6 flex items-center justify-between py-1.5 pl-8 pr-8 text-left text-sm text-gray-500 md:mt-0 md:justify-end md:space-x-4 md:pl-0 md:pr-8 lg:table-cell lg:justify-start lg:py-4 lg:text-right ">
      <RouterLink
        class="inline-flex items-center space-x-2 rounded-full text-colescba-blue-500 transition duration-150 ease-in-out hover:text-colescba-blue-300 focus:outline-none focus:ring-2 focus:ring-colescba-blue-400 focus:ring-offset-4"
        title="Ver detalle autorización" :to="{
          name: 'VerAutorizacion',
          params: { solicitud, solicitud_id: solicitud.solicitudId },
        }">
        <span class="lg:hidden">Ver detalle</span>
        <OutlineInformationCircleIcon class="h-7 w-7" />
      </RouterLink>

      <button title="Presentar" @click="presentarSolicitud()" v-if="isSolicitudEstadoPPR()"
        class="inline-flex items-center space-x-2 rounded-full text-colescba-blue-500 transition duration-150 ease-in-out hover:text-colescba-blue-300 focus:outline-none focus:ring-2 focus:ring-colescba-blue-400 focus:ring-offset-4">
        <span class="lg:hidden">Presentar</span>

        <OutlinePresentIcon class="h-7 w-7 fill-current" />
      </button>


      <button title="Modificar autorización" @click="editarSolicitud()" v-if="canEdit(solicitud)"
        class="inline-flex items-center space-x-2 rounded-full text-colescba-blue-500 transition duration-150 ease-in-out hover:text-colescba-blue-300 focus:outline-none focus:ring-2 focus:ring-colescba-blue-400 focus:ring-offset-4">
        <span class="lg:hidden">Modificar</span>

        <OutlinePencilAltIcon class="h-7 w-7 " />
      </button>

      <button title="Reenviar notificación" v-if="isSolicitudEstadoRTP()" @click="openModalReenviarNotificacion()" :disabled="isSendingNotificacion"
        class="inline-flex items-center space-x-2 rounded-full text-colescba-blue-500 transition duration-150 ease-in-out hover:text-colescba-blue-300 focus:outline-none focus:ring-2 focus:ring-colescba-blue-400 focus:ring-offset-4">
        <span class="lg:hidden">Reenviar notificación</span>

        <SolidForwardToInboxIcon v-if="!isSendingNotificacion" class="h-7 w-7" />
        <LoadingCircle v-else class="h-7 w-7" />
      </button>

      <button title="Verificar notificación" v-if="isSolicitudEstadoRTP()" @click="verificarNotificacion()" :disabled="ischeckingNotificacion"
        class="inline-flex items-center space-x-2 rounded-full text-colescba-blue-500 transition duration-150 ease-in-out hover:text-colescba-blue-300 focus:outline-none focus:ring-2 focus:ring-colescba-blue-400 focus:ring-offset-4">
        <span class="lg:hidden">Verificar notificación</span>

        <OutlineCheckCircleIcon v-if="!ischeckingNotificacion" class="h-7 w-7" />
        <LoadingCircle v-else class="h-7 w-7" />
      </button>

      <button v-if="isSolicitudEstadoRTV()" title="Ver notificación" @click="verNotificacion()"
        class="inline-flex items-center space-x-2 rounded-full text-colescba-blue-500 transition duration-150 ease-in-out hover:text-colescba-blue-300 focus:outline-none focus:ring-2 focus:ring-colescba-blue-400 focus:ring-offset-4">
        <span class="lg:hidden">Ver notificación</span>

        <OutlineGmailIcon class="h-7 w-7" />
      </button>



      <button v-if="this.solicitud.archivoId && !isSolicitudEstadoPPR()" title="Descargar solicitud firmada"
        @click="dowloaderDocumentFirmado()" :disabled="previewingPDFSolicitudAutorizacion"
        class="inline-flex items-center space-x-2 rounded-full text-colescba-blue-500 transition duration-150 ease-in-out hover:text-colescba-blue-300 focus:outline-none focus:ring-2 focus:ring-colescba-blue-400 focus:ring-offset-4">
        <span v-if="previewingPDFSolicitudAutorizacion">
          <LoadingCircle class="h-7 w-7" />
        </span>
        <span v-else>
          <span class="lg:hidden">Descargar</span>
          <OutlineDownloadIcon class="h-7 w-7" />
        </span>
      </button>



    </td>
  </tr>
</template>

<script>
import {
  useComposeModal,
  useAcreditacionServicio,
  useAcreditacionRolNotario,
  useSession,
} from '@colescba/ui'
import { useLoading } from '@/composables/loading'
import moment from 'moment'
import { isEditable, TIPOS_SOLICITUD, ESTADOS_SOLICITUD } from '@/model'
import { useService, useModal, useEnv } from '@colescba/app-vue'
import ReenviarNotificacion from '../Modals/ReenviarNotificacionModal.vue'
import VerificarNotificacion from '../Modals/VerificarNotificacionModal.vue'
import VerNotificacion from '../Modals/VerNotificacion.vue'
import PrintSolicitud from '../Print/PrintSolicitud.vue'
import Vue from 'vue'

export default {
  name: 'ItemTable',

  mixins: [
    useService('api', 'gestorArchivos'),
    useModal(),
    useComposeModal(),
    useLoading(),
    useSession(),
    useAcreditacionServicio(),
    useAcreditacionRolNotario(),
    useEnv('VUE_APP_CODIGO_INVOCACION_SERVICIO'),
  ],

  props: {
    solicitud: { type: Object, required: true },
  },

  data() {
    return {
      isSendingNotificacion: false,
      ischeckingNotificacion: false,
      previewingPDFSolicitud: false,
      previewingPDFSolicitudAutorizacion: false,
    }
  },
  computed: {
    fechaTramite: function () {
      if (this.solicitud.fechaTramite)
        return moment(this.solicitud.fechaTramite).format('DD-MM-YYYY')
      else return '-'
    },
    nroTramite: function () {
      if (this.solicitud.numeroTramite && !this.isSolicitudRVT())
        return this.solicitud.numeroTramite
      else return '-'
    },
  },

  methods: {
    canEdit(solicitud) {
      return isEditable(solicitud) && this.solicitud.estado.estadoId === ESTADOS_SOLICITUD.SOLICITUD_GENERAL_AUTORIZADA
    },
    isSolicitudEstadoRTP() {
      return ESTADOS_SOLICITUD.REVOCATORIA_TOTAL_PENDIENTE === this.solicitud.estado.estadoId
    },
    isSolicitudEstadoRTV() {
      return ESTADOS_SOLICITUD.REVOCATORIA_TOTAL_VERIFICADA === this.solicitud.estado.estadoId
    },
    isSolicitudRVT() {
      return TIPOS_SOLICITUD.REVOCATORIA_TOTAL === this.solicitud.tipo.id
    },
    isAutorizacion() {
      return TIPOS_SOLICITUD.AUTORIZACION === this.solicitud.tipo.id
    },
    isSolicitudEstadoPPR() {
      return ESTADOS_SOLICITUD.PENDIENTE_DE_PRESENTACION === this.solicitud.estado.estadoId
    },


    async openModalReenviarNotificacion() {
      const modal = await this.useModal({
        modalId: 'reenviar-notificacion',
        type: ReenviarNotificacion,
        props: {
          notificacion: this.solicitud.notificacion,
          solicitudId: this.solicitud.solicitudId,
        },
        parent: this.$parent,
      })
      modal.open()
    },

    async verificarNotificacion() {
      const modal = await this.useModal({
        modalId: 'verificar-notificacion',
        type: VerificarNotificacion,
        props: {
          solicitudId: this.solicitud.solicitudId,
          onConfirm: () => this.$emit('solicitudes-updated'),
        },
        parent: this.$parent,
      })
      modal.open()
    },
    async verNotificacion() {
      const modal = await this.useModal({
        modalId: 'ver-notificacion',
        type: VerNotificacion,
        props: {
          notificacion: this.solicitud.notificacion,
        },
      })
      modal.open()
    },
    async dowloader() {
      this.previewingPDFSolicitud = true
      const ComponentClass = Vue.extend(PrintSolicitud)
      const constancia = await new ComponentClass({
        propsData: {
          solicitud: this.solicitud,
          notario: this.notario,
          title: 'TRÁMITE DE REVOCATORIA TOTAL',
          filename: 'constancia_solicitud',
        },
        parent: this.$parent,
      }).$mount()
      this.previewingPDFSolicitud = false
    },
    async dowloaderDocumentFirmado() {
      this.previewingPDFSolicitudAutorizacion = true
      this.asyncLoad('downloading', async () => {
        await this.gestorArchivos.downloadFile(
          this.solicitud.archivoId,
          'migraciones_' + this.solicitud.numeroTramite + '.pdf',
          {
            usuarioId: this.usuarioActivo.usuarioId,
            servicioSolicitante: this.VUE_APP_CODIGO_INVOCACION_SERVICIO,
          },
        )
      })
      this.previewingPDFSolicitudAutorizacion = false
    },
    presentarSolicitud() {
      this.$router.push({
        name: 'Presentar',
        params: { solicitudId: this.solicitud.solicitudId },
      })
    },
    editarSolicitud() {
      this.$router.push({
        name: 'EditarAutorizacion',
        params: { solicitud: this.solicitud, solicitud_id: this.solicitud.solicitudId },
      })
    },
  },


}
</script>
